import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { MatomoService } from '@client/app/modules/tracking/services/matomo.service';
import { TrackingRunService } from '@client/app/modules/tracking/run/tracking.service';

export function init_app (trackingRunService: TrackingRunService) {
    return () => trackingRunService.initializeApp();
}

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [MatomoService, provideAppInitializer(() => {
        const initializerFn = (init_app)(inject(TrackingRunService));
        return initializerFn();
    })],
})

export class TrackingModule {}
